import React, {useMemo, useState} from 'react';
import {Tag} from 'antd';
import TablePage from "../../../pages/tablePage/TablePage";
import IsLoading from "../../../shared/components/IsLoading";
import ErrorPage from "../../../shared/components/ErrorPage";
import {useTrophyChallengeGroup, useTrophyChallengeResourceList} from "./useTrophyChallenge";
import TrophyChallengeGroupEditModal from "./TrophyChallengeGroupEditModal";
import {TrophyChallengeGroupEntity} from "./TrophyChallengeGroupEntity";

const TrophyChallengeGroupManager = () => {
    const [rowData, setRowData] = useState(null);
    const {data, isLoading, error} = useTrophyChallengeGroup();
    const {data: resourceOptions} = useTrophyChallengeResourceList();

    const columns = useMemo(() => ([
        {
            title: '번호',
            dataIndex: 'seq',
            key: 'seq',
            width: 80,
            sorter: (a, b) => a.seq - b.seq,
        },
        {
            title: '메모',
            dataIndex: 'memo',
            key: 'memo',
        },
        {
            title: '리소스 번호',
            dataIndex: 'resourceIdx',
            key: 'resourceIdx',
            width: 110,
        },
        {
            title: '최종 보상',
            dataIndex: 'completeReward',
            key: 'completeReward',
            render: (val) => {
                const rewards = Array.isArray(val)
                    ? val
                    : (typeof val === 'string' && val ? val.split(',').map(Number) : []);
                return rewards.map((r, i) => <Tag key={i} color="blue">{r}</Tag>);
            },
        },
        {
            title: '최소 적용 버전',
            dataIndex: 'minVersion',
            key: 'minVersion',
            width: 130,
        },
    ]), []);

    if (isLoading) return <IsLoading/>;
    if (error) return <ErrorPage error={error}/>;

    const props = {
        columns,
        localData: data || [],
        modal: TrophyChallengeGroupEditModal,
        buttonText: '챌린지 그룹 추가',
        rowData,
        setRowData,
        entityModel: TrophyChallengeGroupEntity,
        modalOptions: {resourceOptions: resourceOptions || []},
        modalWidth: 600,
        modalResizable: true,
    };

    return <TablePage {...props}/>;
};

export default TrophyChallengeGroupManager;
